var formObject = {
    //表单初始化的参数
    _Q_:{},
    //表单的存储数据
    __FORMDATA:null,
    //模块元数据配置信息
    METACONFIG:[],
    //页面上所有组件已绑定元数据的所需要的数据源
    COMPONENTDATA:[],
    //依据表单&节点权限设置信息
    ROLEDATA:null,
    //节点列表信息
    FLOWNODE:null,
}
function getQueryObject(){
    return this.formObject._Q_;
}
function setQueryObject(_Q_){
    return this.formObject._Q_=_Q_;
}
function getFormData(){
    return this.formObject.__FORMDATA;
}
function setFormData(Data){
    return this.formObject.__FORMDATA=Data;
}
function getMetaConfig(){
    return this.formObject.METACONFIG;
}
function setMetaConfig(Data){
    return this.formObject.METACONFIG=Data;
}
function getComponentData(){
    return this.formObject.COMPONENTDATA;
}
function setComponentData(Data){
    return this.formObject.COMPONENTDATA=Data;
}
function getRoleData(){
    return this.formObject.ROLEDATA;
}
function setRoleData(Data){
    return this.formObject.ROLEDATA=Data;
}
function getFlowNode(){
    return this.formObject.FLOWNODE;
}
function setFlowNode(Data){
    return this.formObject.FLOWNODE=Data;
}

export default {
    formObject,
    getQueryObject,
    setQueryObject,
    getFormData,
    setFormData,
    getMetaConfig,
    setMetaConfig,
    getComponentData,
    setComponentData,
    getRoleData,
    setRoleData,
    getFlowNode,
    setFlowNode
}